import { render, staticRenderFns } from "./ValorAberto.vue?vue&type=template&id=3c897a1b&scoped=true&"
import script from "./ValorAberto.vue?vue&type=script&lang=js&"
export * from "./ValorAberto.vue?vue&type=script&lang=js&"
import style0 from "./ValorAberto.vue?vue&type=style&index=0&id=3c897a1b&scoped=true&lang=css&"
import style1 from "./ValorAberto.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c897a1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
